import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  "class": "fc_global_form_builder"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_with_label = _resolveComponent("with-label");
  var _component_el_form = _resolveComponent("el-form");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
    onSubmit: _withModifiers($options.nativeSave, ["prevent"]),
    data: $props.formData,
    "label-position": $props.label_position
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.fields, function (field, fieldIndex) {
        return _openBlock(), _createBlock(_component_with_label, {
          key: fieldIndex,
          field: field
        }, {
          "default": _withCtx(function () {
            return [(_openBlock(), _createBlock(_resolveDynamicComponent(field.type), {
              suggests: $props.suggests,
              modelValue: $props.formData[fieldIndex],
              "onUpdate:modelValue": function onUpdateModelValue($event) {
                return $props.formData[fieldIndex] = $event;
              },
              field: field
            }, null, 8 /* PROPS */, ["suggests", "modelValue", "onUpdate:modelValue", "field"]))];
          }),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["field"]);
      }), 128 /* KEYED_FRAGMENT */))];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["onSubmit", "data", "label-position"])]);
}